"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deployAddress = exports.deployTxn = exports.ABI = exports.bytecode = void 0;
exports.deployStoreIfNeeded = deployStoreIfNeeded;
exports.storeWrite = storeWrite;
exports.storeRead = storeRead;
/*
contract Storage {
    mapping(address => mapping(bytes32 => bytes)) store;

    function set(bytes32 k, bytes memory v) external {
        store[msg.sender][k] = v;
    }

    function get(bytes32 k) external view returns (bytes memory) {
        return store[msg.sender][k];
    }

    function getWithAddress(address s, bytes32 k) external view returns (bytes memory) {
        return store[s][k];
    }
}
*/
const viem = __importStar(require("viem"));
exports.bytecode = '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';
exports.ABI = [
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'k',
                type: 'bytes32',
            },
        ],
        name: 'get',
        outputs: [
            {
                internalType: 'bytes',
                name: '',
                type: 'bytes',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 's',
                type: 'address',
            },
            {
                internalType: 'bytes32',
                name: 'k',
                type: 'bytes32',
            },
        ],
        name: 'getWithAddress',
        outputs: [
            {
                internalType: 'bytes',
                name: '',
                type: 'bytes',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'k',
                type: 'bytes32',
            },
            {
                internalType: 'bytes',
                name: 'v',
                type: 'bytes',
            },
        ],
        name: 'set',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
];
exports.deployTxn = {
    to: '0x4e59b44847b379578588920ca78fbf26c0b4956c',
    data: (viem.pad('0x', { size: 32 }) + exports.bytecode.split('0x')[1]),
};
exports.deployAddress = '0x14570ce88f490a80342cc156a6a0ebc173609f5e';
async function deployStoreIfNeeded(publicClient, signer) {
    const code = await publicClient.getCode({ address: exports.deployAddress });
    if (!code || code === '0x') {
        const txHash = await signer.wallet.sendTransaction({
            ...exports.deployTxn,
            account: signer.wallet.account || signer.address,
            chain: signer.wallet.chain,
        });
        await publicClient.waitForTransactionReceipt({ hash: txHash });
    }
}
async function storeWrite(publicClient, signer, k, v) {
    await deployStoreIfNeeded(publicClient, signer);
    const txHash = await signer.wallet.writeContract({
        account: signer.wallet.account || signer.address,
        chain: signer.wallet.chain,
        address: exports.deployAddress,
        abi: exports.ABI,
        functionName: 'set',
        args: [k, viem.toHex(v)],
    });
    return await publicClient.waitForTransactionReceipt({ hash: txHash });
}
async function storeRead(publicClient, space, k) {
    return viem.hexToString((await publicClient.readContract({
        address: exports.deployAddress,
        abi: exports.ABI,
        functionName: 'getWithAddress',
        args: [space, k],
    })));
}
//# sourceMappingURL=onchain-store.js.map